export const Paths = {
  DEFAULT: '/',
  INVOICES: '/invoices',
  INVOICE_DETAILS: '/invoices/details',
  PAY_INVOICE: '/invoices/pay',
  QUOTES: '/quotes',
  QUOTE_DETAILS: '/quotes/details',
  SUBSCRIPTIONS: '/subscriptions',
  PAYMENT_METHODS: '/payment-methods',
  PAYMENT_HISTORY: '/payment-history',
  UPDATE_PAYMENT_METHOD: '/update-payment-method'
};
export const DEFAULT_ROUTE = Paths.SUBSCRIPTIONS;